import { BankAccountDto, InvoiceFormData } from "@/types";
import { ocrBankAccountType, ocrBankAccountExists } from "@/utils/invoiceUtils";
import { useCallback } from "react";
import { useFormContext } from "react-hook-form";
import { PrefilledBadge, ModifiedBadge } from "../../../invoiceAttachmentSection/PreFilledInformation";

type BankAccountPrefilledBadgeProps = {
    bankAccounts?: BankAccountDto[];
    ocrBankAccount?: ocrBankAccountType;
    bankAccount?: BankAccountDto;
};

export const BankAccountPrefilledBadge = ({
    bankAccounts,
    ocrBankAccount,
    bankAccount
}: BankAccountPrefilledBadgeProps) => {
    const { setValue } = useFormContext<InvoiceFormData>();

    const bankAccountsMatch = (a?: BankAccountDto, b?: ocrBankAccountType) =>
        a?.accountNumber === b?.accountNumber && a?.currency === b?.currency;

    const ocrBankAccExists = ocrBankAccountExists(bankAccounts, ocrBankAccount);
    const isModified = !bankAccountsMatch(bankAccount, ocrBankAccount);

    const showPrefilledBadge = ocrBankAccExists && !isModified;
    const showModifiedBadge = ocrBankAccExists && isModified;

    const handleUndo = useCallback(() => {
        if (!ocrBankAccount) {
            return;
        }

        const original = bankAccounts?.find(b => bankAccountsMatch(b, ocrBankAccount));
        if (original) {
            setValue("bankAccount", original, { shouldDirty: true, shouldValidate: true });
        }
    }, [bankAccounts, ocrBankAccount, setValue]);

    if (!ocrBankAccount?.currency) {
        return null;
    }

    return (
        <>
            {showPrefilledBadge && <PrefilledBadge />}
            {showModifiedBadge && <ModifiedBadge handleUndo={handleUndo} />}
        </>
    );
};
